"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomStyles = exports.SubLabelSpan = exports.PencilIcon = exports.OptionWrapper = exports.LabelSpan = exports.IconSpan = exports.DEFAULT_STYLES = exports.CustomIconContainer = exports.ArrowIcon = void 0;
exports.getDropdownBorderRadius = getDropdownBorderRadius;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireDefault(require("styled-is"));
var _ArrowDown = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowDown16"));
var _Pencil = _interopRequireDefault(require("@honeybook/icons/dist/icons/Pencil16"));
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _variables = require("../../styles/variables");
var _variables2 = require("../HBTextField/variables");
var _HBText = require("../HBText/HBText.styles");
var _templateObject, _templateObject2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFAULT_STYLES = exports.DEFAULT_STYLES = {
  control: {
    borderRadius: 4,
    warningColor: _colors["default"].red50
  }
};
function getDropdownBorderRadius(borderRadius, size) {
  var percentBorderRadius = borderRadius / 100;
  return percentBorderRadius * parseInt(_variables2.INPUT_SIZE_PROPS.builder[size].height, 10);
}
var IconSpan = exports.IconSpan = _styledComponents["default"].span.withConfig({
  displayName: "HBDropdownstyles__IconSpan",
  componentId: "sc-xd300s-0"
})(["display:flex;justify-content:center;align-items:center;padding-right:6px;i{display:flex;}"]);
var OptionWrapper = exports.OptionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBDropdownstyles__OptionWrapper",
  componentId: "sc-xd300s-1"
})(["display:flex;align-items:center;width:100%;", ""], (0, _styledIs["default"])('isSubLabel')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        gap: ", ";\n    "])), _spacing["default"][4]));
var LabelSpan = exports.LabelSpan = _styledComponents["default"].span.withConfig({
  displayName: "HBDropdownstyles__LabelSpan",
  componentId: "sc-xd300s-2"
})(["display:inline-block;white-space:nowrap;text-overflow:ellipsis;overflow-x:hidden;max-width:100%;", ""], (0, _styledIs["default"])('hasIcon')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        margin-right: auto;\n    "]))));
var SubLabelSpan = exports.SubLabelSpan = _styledComponents["default"].div.withConfig({
  displayName: "HBDropdownstyles__SubLabelSpan",
  componentId: "sc-xd300s-3"
})(["position:relative;top:1px;color:", ";font-size:12px;white-space:nowrap;text-overflow:ellipsis;overflow-x:clip;max-width:90%;font-weight:400;"], function (props) {
  return props.$isSubLabelGreyed ? _colors["default"].textDisabled : _colors["default"].textTertiary;
});
var getCustomStyles = exports.getCustomStyles = function getCustomStyles(_ref) {
  var dropdownTheme = _ref.dropdownTheme,
    ignoreStylesOf = _ref.ignoreStylesOf,
    _ref$customStyles = _ref.customStyles,
    customStyles = _ref$customStyles === void 0 ? {} : _ref$customStyles,
    _ref$focusStyles = _ref.focusStyles,
    focusStyles = _ref$focusStyles === void 0 ? {} : _ref$focusStyles,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? 'system' : _ref$scope,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$outlineColor = _ref.outlineColor,
    outlineColor = _ref$outlineColor === void 0 ? _colors["default"].neutral200 : _ref$outlineColor,
    withIcon = _ref.withIcon,
    menuAlign = _ref.menuAlign;
  var styles = {
    container: function container(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        fontSize: '14px',
        minWidth: '100px',
        width: '100%',
        fontFamily: 'ProximaNova,Arial,sans-serif',
        cursor: state.isDisabled ? 'not-allowed' : 'pointer'
      }, customStyles.container);
    },
    control: function control(provided, state) {
      var controlStyles = _objectSpread(_objectSpread({}, provided), {}, {
        display: 'flex',
        borderRadius: "".concat(DEFAULT_STYLES.control.borderRadius, "px"),
        cursor: 'pointer',
        height: _variables2.INPUT_SIZE_PROPS[scope][size].height,
        minHeight: '36px',
        boxShadow: 'none',
        '&:hover, &:focus-within': {
          borderColor: error ? DEFAULT_STYLES.control.warningColor : outlineColor
        },
        border: "1px solid ".concat(error ? DEFAULT_STYLES.control.warningColor : _colors["default"].transparent)
      });
      switch (dropdownTheme) {
        case 'plain':
          {
            return _objectSpread(_objectSpread({}, controlStyles), {}, {
              background: state.menuIsOpen ? _colors["default"].white_04 : _colors["default"].white,
              border: "1px solid ".concat(error ? _colors["default"].red50 : _colors["default"].neutral200),
              boxShadow: "0 1px 2px 0 ".concat(_colors["default"].black_005)
            }, customStyles.control);
          }
        case 'underline':
          {
            return _objectSpread(_objectSpread({}, controlStyles), {}, {
              background: _colors["default"].white,
              borderWidth: 0,
              borderStyle: 'none',
              borderBottom: "1px solid ".concat(error ? _colors["default"].red50 : _colors["default"].neutral600),
              borderRadius: 0
            }, customStyles.control);
          }
        case 'transparent':
          {
            return _objectSpread(_objectSpread(_objectSpread({}, controlStyles), customStyles.control), {}, {
              background: _colors["default"].transparent,
              '&:hover': {
                borderColor: _colors["default"].transparent
              }
            });
          }
        default:
          {
            var result = _objectSpread(_objectSpread({}, controlStyles), {}, {
              background: state.menuIsOpen || state.isFocused ? _colors["default"].neutral200 : _colors["default"].neutral100,
              borderWidth: 0,
              color: state.isDisabled ? _colors["default"].neutral600 : _colors["default"].neutral900
            }, customStyles.control);
            if (state.menuIsOpen) {
              result = _objectSpread(_objectSpread({}, result), focusStyles);
            }
            return result;
          }
      }
    },
    dropdownIndicator: function dropdownIndicator(provided) {
      return _objectSpread(_objectSpread({}, provided), customStyles.dropdownIndicator);
    },
    clearIndicator: function clearIndicator(provided) {
      return _objectSpread(_objectSpread({}, provided), customStyles.clearIndicator);
    },
    indicatorSeparator: function indicatorSeparator() {
      return _objectSpread({}, customStyles.indicatorSeparator);
    },
    indicatorsContainer: function indicatorsContainer(provided) {
      return _objectSpread(_objectSpread({}, provided), customStyles.indicatorsContainer);
    },
    placeholder: function placeholder(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        width: '98%',
        padding: 0,
        margin: 0,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: _colors["default"].textTertiary
      }, customStyles.placeholder);
    },
    menu: function menu(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        borderRadius: '4px',
        margin: '4px 0 0 0',
        boxShadow: "0 14px 28px 0 ".concat(_colors["default"].blue_015, ", 0 0 4px 0 ").concat(_colors["default"].blue_006),
        'z-index': "".concat(_variables.Z_INDEX.TOP_MOST),
        right: menuAlign === 'end' ? 0 : null,
        minWidth: '100%',
        width: 'max-content',
        maxWidth: '400px'
      }, customStyles.menu);
    },
    menuList: function menuList(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        padding: 0
      }, customStyles.menuList);
    },
    menuPortal: function menuPortal(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        zIndex: _variables.Z_INDEX.POPOVER + _variables.Z_INDEX.TOP_MOST
      }, customStyles.menuPortal);
    },
    option: function option(provided, state) {
      return _objectSpread({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '12px',
        paddingRight: '12px',
        minHeight: '40px',
        backgroundColor: state.isFocused ? _colors["default"].neutral100 : 'transparent',
        borderBottom: "1px solid ".concat(_colors["default"].neutral200),
        color: state.isDisabled ? provided.color : _colors["default"].textPrimary,
        userSelect: state.isDisabled ? 'none' : 'all',
        cursor: state.isDisabled ? 'default' : 'pointer',
        ':active': {
          backgroundColor: _colors["default"].neutral100
        },
        '&:hover': {
          background: _colors["default"].neutral100
        },
        '&:first-of-type': {
          borderTopLeftRadius: '2px',
          borderTopRightRadius: '2px'
        },
        '&:last-of-type': {
          borderBottomColor: _colors["default"].transparent,
          borderBottomLeftRadius: '2px',
          borderBottomRightRadius: '2px'
        }
      }, typeof customStyles.option === 'function' ? customStyles.option(provided, state) : customStyles.option);
    },
    singleValue: function singleValue(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        color: _colors["default"].neutral900
      }, customStyles.singleValue);
    },
    valueContainer: function valueContainer(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        flexWrap: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        paddingLeft: withIcon ? '8px' : '12px'
      }, customStyles.valueContainer);
    },
    input: function input(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        display: 'flex',
        alignItems: 'center',
        padding: 0,
        margin: 0,
        input: {
          fontFamily: 'inherit'
        }
      }, customStyles.input);
    },
    groupHeading: function groupHeading(provided) {
      return _objectSpread(_objectSpread(_objectSpread({}, provided), {}, {
        padding: '12px 12px 8px',
        display: 'flex',
        alignItems: 'end',
        color: _colors["default"].textTertiary
      }, _HBText.newTextStyles.subtitle12), customStyles.groupHeading);
    },
    group: function group(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        '&:not(:last-of-type)': {
          borderBottom: "1px solid ".concat(_colors["default"].neutral200)
        }
      }, customStyles.group);
    }
  };
  Object.keys(ignoreStylesOf).forEach(function (styleType) {
    if (ignoreStylesOf[styleType]) {
      styles[styleType] = function () {};
    }
  });
  return styles;
};
var ArrowIcon = exports.ArrowIcon = (0, _styledComponents["default"])(_ArrowDown["default"]).withConfig({
  displayName: "HBDropdownstyles__ArrowIcon",
  componentId: "sc-xd300s-4"
})(["display:flex;"]);
var PencilIcon = exports.PencilIcon = (0, _styledComponents["default"])(_Pencil["default"]).withConfig({
  displayName: "HBDropdownstyles__PencilIcon",
  componentId: "sc-xd300s-5"
})(["display:flex;"]);
var CustomIconContainer = exports.CustomIconContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBDropdownstyles__CustomIconContainer",
  componentId: "sc-xd300s-6"
})(["i{display:flex;}padding-left:12px;"]);
//# sourceMappingURL=HBDropdown.styles.js.map